import styles from './copy-instructor-dialog.module.scss';
import { Col, Row } from 'reactstrap';
import { ChangeEvent, useContext, useEffect, useState } from 'react';
import { makeCourseRequest, useCourseGetRequestHook } from 'libs/webkua-lib/src/lib/requestUtils';
import { Dialog, DialogActions, DialogContent, DialogTitle, GrayOutlinedButton, LoadingButton, SnackBarContext, TextField } from '@frontend-workspace/react-shared-lib';
import { IInstructor } from '../../../../_models/instructor';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface CopyInstructorDialogProps {
  onClose: () => void,
  open: boolean,
  refreshData: () => void,
  instructorId: string
}

export function CopyInstructorDialog(props: CopyInstructorDialogProps) {
  const { data: instructor }: { data: IInstructor } = useCourseGetRequestHook(`resource/instructor/${props.instructorId}`, undefined);

  const { setSnackbarMessage } = useContext(SnackBarContext);
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);
  const [adskInstructorId, setAdskInstructorId] = useState<string>('');
  const [firstName, setFirstName] = useState<string>('');
  const [lastName, setLastName] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [companyName, setCompanyName] = useState<string>('');
  const [city, setCity] = useState<string>('');

  const handleAdskInstructorIdChange = (event: ChangeEvent<HTMLInputElement>) => setAdskInstructorId(event.target.value);
  const handlefirstNameChange = (event: ChangeEvent<HTMLInputElement>) => setFirstName(event.target.value);
  const handlelastNameChange = (event: ChangeEvent<HTMLInputElement>) => setLastName(event.target.value);
  const handleEmailChange = (event: ChangeEvent<HTMLInputElement>) => setEmail(event.target.value);
  const handleCompanyChange = (event: ChangeEvent<HTMLInputElement>) => setCompanyName(event.target.value);
  const handleCityChange = (event: ChangeEvent<HTMLInputElement>) => setCity(event.target.value);

  useEffect(() => {
    if (instructor) {
      setAdskInstructorId(instructor.adskInstructorId);
      setFirstName(instructor.person?.firstName);
      setLastName(instructor.person?.lastName);
      setEmail(instructor.person?.email + ' (kopi)');
      setCompanyName(instructor.person?.companyName);
      setCity(instructor.city);
    }
  }, [instructor]);

  const missingFields = (): boolean => {
    const requiredFieldsFilled =
      firstName &&
      lastName &&
      email &&
      companyName &&
      city;
    return requiredFieldsFilled ? false : true;
  };

  // Todo::
  // Status: Får ikke testet fordi epostene må finnes i SuperOffice, og i test er de slik: '@mailinator.com'
  const handleAddInstructor = () => {
    setLoading(true);
    const body = {
      person: {
        firstName: firstName,
        lastName: lastName,
        email: email,
        companyName: companyName
      },
      adskInstructorId: adskInstructorId,
      city: city
    }
    makeCourseRequest(`resource/instructor/upsert`, 'POST', body).then(result => {
      setSnackbarMessage({ content: t('standard.addedInstructorToList'), type: "info", });
      setLoading(false);
      props.refreshData();
      props.onClose();
    }).catch(() => {
      // Uses app.tsx => error.response.data => SnackbarMessage
      // setSnackbarMessage({ content: "Kunne ikke legge til instruktør i listen.", type: "error" })
    });
  };

  return (
    <Dialog
      open={props.open}
      maxWidth="sm"
      fullWidth>
      <DialogTitle className='mb-4'>
        {t('standard.newInstructor')} <small className='MuiTypography-body3'>(${t('standard.copy')})</small>
      </DialogTitle>
      <DialogContent>
        <Row>
          <Col xl={6}>
            <div className='mb-3'>
              <TextField
                label={t('standard.adskInstructorId')}
                name='adskInstructorId'
                fullWidth
                sx={{ minWidth: 300 }}
                value={adskInstructorId || ''}
                onChange={handleAdskInstructorIdChange}
              />
            </div>
          </Col>
        </Row>
        <div className='mb-3'>
          <TextField
            label={<span>{t('standard.firstName')} &#42;</span>}
            name='firstName'
            fullWidth
            sx={{ minWidth: 300 }}
            value={firstName || ''}
            onChange={handlefirstNameChange}
          />
        </div>
        <div className='mb-3'>
          <TextField
            label={<span>{t('standard.lastName')} &#42;</span>}
            name='lastName'
            fullWidth
            sx={{ minWidth: 300 }}
            value={lastName || ''}
            onChange={handlelastNameChange}
          />
        </div>
        <div className='mb-3'>
          <TextField
            label={<span>{t('standard.email')} &#42;</span>}
            name='email'
            fullWidth
            sx={{ minWidth: 300 }}
            value={email || ''}
            onChange={handleEmailChange}
          />
        </div>
        <div className='mb-3'>
          <TextField
            label={<span>{t('standard.company')} &#42;</span>}
            name='company'
            fullWidth
            sx={{ minWidth: 300 }}
            value={companyName || ''}
            onChange={handleCompanyChange}
          />
        </div>
        <div className='mb-3'>
          <TextField
            label={<span>{t('standard.city')} &#42;</span>}
            name='city'
            fullWidth
            sx={{ minWidth: 300 }}
            value={city || ''}
            onChange={handleCityChange}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          variant="contained"
          size='large'
          onClick={handleAddInstructor}
          disabled={loading || missingFields()}
          loading={loading}
          className='minButtonWidth'>
          {loading ? '' : t('copyInstructor.createInstructor')}
        </LoadingButton>
        <GrayOutlinedButton
          variant="outlined"
          size='large'
          onClick={props.onClose}
          className='minButtonWidth'>
          {t('standard.cancel')}
        </GrayOutlinedButton>
      </DialogActions>
    </Dialog>
  );
}

export default CopyInstructorDialog;
